import { useMemo } from "react";

import { useQuery } from "@apollo/client";

import { renderErrorMessage } from "Services/LoggingService";
import { EventDefinition } from "Types/EventDefinition";

import { GetEventsReceivedQueryResponse, getEventsReceived } from "../queries";

type HookReturn = {
    events: EventDefinition[];
    loading: boolean;
    refetch: () => void;
};

export function useEventData(): HookReturn {
    const { data, loading, refetch } = useQuery<GetEventsReceivedQueryResponse>(getEventsReceived, {
        variables: {
            eventType: "track",
        },
        fetchPolicy: "no-cache",
        onError(error) {
            renderErrorMessage({
                content: "Couldn't retrieve event definitions.",
                error,
                loggerContext: "ivr eventdefinitions node",
            });
        },
    });

    const events = useMemo(() => data?.getEventsReceived ?? [], [data?.getEventsReceived]);

    return {
        loading,
        events,
        refetch,
    };
}
